import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ArrowRight } from 'lucide-react';
import type { AdTemplate } from '@shared/schema';
import { adStyleOf } from './ad-style';
import { useCanvasStore } from './canvas-store';

/** A short optional sampler. The existing library retains every style, filter,
 * reference and clone action, rather than repeating the library on Create. */
export function DiscoverSections() {
  const { data: templates = [] } = useQuery<AdTemplate[]>({ queryKey: ['/api/ad-templates'] });
  const openAdLibrary = useCanvasStore(s => s.openAdLibrary);
  const samples = useMemo(() => {
    const styles = new Set<string>();
    const distinct = templates.filter(template => {
      const style = adStyleOf(template);
      if (styles.has(style)) return false;
      styles.add(style);
      return true;
    });
    const chosen = distinct.slice(0, 4);
    for (const template of templates) {
      if (chosen.length >= 4) break;
      if (!chosen.some(item => item.id === template.id)) chosen.push(template);
    }
    return chosen;
  }, [templates]);
  if (!samples.length) return null;
  return (
    <section className="adoption-inspiration" aria-labelledby="inspiration-title">
      <div className="adoption-inspiration-header">
        <div>
          <h2 id="inspiration-title">A little inspiration.</h2>
          <p>Pick a direction. Make it yours.</p>
        </div>
        <button type="button" className="adoption-text-link" onClick={() => openAdLibrary([])}>
          Browse all inspiration <ArrowRight size={14} style={{ display: 'inline', marginLeft: 4 }} aria-hidden="true" />
        </button>
      </div>
      <div className="adoption-inspiration-grid">
        {samples.map(template => (
          <button key={template.id} type="button" className="adoption-discover-card" data-testid={`discover-card-${template.id}`}
            aria-label={`Use ${template.name} as inspiration`} onClick={() => openAdLibrary([adStyleOf(template)], template.id)}>
            <img src={template.imageUrl} alt={template.name} loading="lazy" />
            <span className="adoption-discover-caption">{adStyleOf(template)} <ArrowRight size={15} aria-hidden="true" /></span>
          </button>
        ))}
      </div>
    </section>
  );
}
